/**
 * FILE-OVERVIEW:
 * - 役割: メモ画面モバイル用の下部ナビゲーション。項目の中身だけを決める。
 * - 主な連携: MemoCalendarMain.tsx, Common/BottomNavBar.tsx
 * - 本番運用上の注意: 見た目は BottomNavBar 側にあるため、位置やサイズの変更は
 *   スケジュール画面のナビにも影響する。
 */

import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ListIcon from '@mui/icons-material/List';
import type FullCalendar from '@fullcalendar/react';

import BottomNavBar from '../Common/BottomNavBar';
import type { BottomNavItem } from '../Common/BottomNavBar';

interface MemoNavigationProps {
  calendarRef: React.RefObject<FullCalendar | null>;
  /** 呼び出し側から渡されるが現状は未使用 */
  onViewChange?: (viewType: string) => void;
}

const MemoNavigation = ({ calendarRef, onViewChange }: MemoNavigationProps) => {
  const handleViewChange = (viewType: string) => {
    if (calendarRef.current) {
      calendarRef.current.getApi().changeView(viewType);
    }
  };

  const navItems: BottomNavItem[] = [
    {
      key: 'prev',
      label: '前へ',
      icon: <ArrowBackIcon fontSize="small" />,
      onClick: () => calendarRef.current?.getApi().prev(),
      isActive: false,
    },
    {
      key: 'day',
      label: '日',
      icon: <CalendarTodayIcon fontSize="small" />,
      onClick: () => handleViewChange('dayGridDay'),
      isActive: false,
    },
    {
      key: 'list',
      label: 'リスト',
      icon: <ListIcon fontSize="small" />,
      onClick: () => handleViewChange('listWeek'),
      isActive: false,
    },
    {
      key: 'today',
      label: '今日',
      icon: <EventAvailableIcon fontSize="small" />,
      onClick: () => calendarRef.current?.getApi().today(),
      isActive: false,
    },
    {
      key: 'next',
      label: '次へ',
      icon: <ArrowForwardIcon fontSize="small" />,
      onClick: () => calendarRef.current?.getApi().next(),
      isActive: false,
    },
  ];

  return <BottomNavBar className="memo-bottom-nav" items={navItems} />;
};

export default MemoNavigation;
